<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <div class="row align-items-center">
        <div class="col-lg-8">
          <div class="d-flex align-items-center mb-3">
            <ul class="pe-4 mb-0 list-unstyled d-flex gap-2">
              <li>
                <i class="ri-star-fill text-warning fs-20"></i>
              </li>
              <li>
                <i class="ri-star-fill text-warning fs-20"></i>
              </li>
              <li>
                <i class="ri-star-fill text-warning fs-20"></i>
              </li>
              <li>
                <i class="ri-star-fill text-warning fs-20"></i>
              </li>
              <li>
                <i class="ri-star-fill text-warning fs-20"></i>
              </li>
            </ul>
            <div
              class="progress w-100 rounded-pill"
              role="progressbar"
              aria-label="Example 5px high"
              aria-valuenow="100"
              aria-valuemin="0"
              aria-valuemax="100"
              style="height: 5px; background-color: #eff2ff"
            >
              <div class="progress-bar rounded-pill" style="width: 100%"></div>
            </div>
            <span class="ms-4">359</span>
          </div>
          <div class="d-flex align-items-center mb-3">
            <ul class="pe-4 mb-0 list-unstyled d-flex gap-2">
              <li>
                <i class="ri-star-fill text-warning fs-20"></i>
              </li>
              <li>
                <i class="ri-star-fill text-warning fs-20"></i>
              </li>
              <li>
                <i class="ri-star-fill text-warning fs-20"></i>
              </li>
              <li>
                <i class="ri-star-fill text-warning fs-20"></i>
              </li>
              <li>
                <i class="ri-star-line text-gray-light fs-20"></i>
              </li>
            </ul>
            <div
              class="progress w-100 rounded-pill"
              role="progressbar"
              aria-label="Example 5px high"
              aria-valuenow="90"
              aria-valuemin="0"
              aria-valuemax="100"
              style="height: 5px; background-color: #eff2ff"
            >
              <div class="progress-bar rounded-pill" style="width: 90%"></div>
            </div>
            <span class="ms-4">208</span>
          </div>
          <div class="d-flex align-items-center mb-3">
            <ul class="pe-4 mb-0 list-unstyled d-flex gap-2">
              <li>
                <i class="ri-star-fill text-warning fs-20"></i>
              </li>
              <li>
                <i class="ri-star-fill text-warning fs-20"></i>
              </li>
              <li>
                <i class="ri-star-fill text-warning fs-20"></i>
              </li>
              <li>
                <i class="ri-star-line text-gray-light fs-20"></i>
              </li>
              <li>
                <i class="ri-star-line text-gray-light fs-20"></i>
              </li>
            </ul>

            <div
              class="progress w-100 rounded-pill"
              role="progressbar"
              aria-label="Example 5px high"
              aria-valuenow="80"
              aria-valuemin="0"
              aria-valuemax="100"
              style="height: 5px; background-color: #eff2ff"
            >
              <div class="progress-bar rounded-pill" style="width: 80%"></div>
            </div>
            <span class="ms-4">124</span>
          </div>
          <div class="d-flex align-items-center mb-3">
            <ul class="pe-4 mb-0 list-unstyled d-flex gap-2">
              <li>
                <i class="ri-star-fill text-warning fs-20"></i>
              </li>
              <li>
                <i class="ri-star-fill text-warning fs-20"></i>
              </li>
              <li>
                <i class="ri-star-line text-gray-light fs-20"></i>
              </li>
              <li>
                <i class="ri-star-line text-gray-light fs-20"></i>
              </li>
              <li>
                <i class="ri-star-line text-gray-light fs-20"></i>
              </li>
            </ul>

            <div
              class="progress w-100 rounded-pill"
              role="progressbar"
              aria-label="Example 5px high"
              aria-valuenow="70"
              aria-valuemin="0"
              aria-valuemax="100"
              style="height: 5px; background-color: #eff2ff"
            >
              <div class="progress-bar rounded-pill" style="width: 70%"></div>
            </div>
            <span class="ms-4">89</span>
          </div>
          <div class="d-flex align-items-center mb-0">
            <ul class="pe-4 mb-0 list-unstyled d-flex gap-2">
              <li>
                <i class="ri-star-fill text-warning fs-20"></i>
              </li>
              <li>
                <i class="ri-star-line text-gray-light fs-20"></i>
              </li>
              <li>
                <i class="ri-star-line text-gray-light fs-20"></i>
              </li>
              <li>
                <i class="ri-star-line text-gray-light fs-20"></i>
              </li>
              <li>
                <i class="ri-star-line text-gray-light fs-20"></i>
              </li>
            </ul>

            <div
              class="progress w-100 rounded-pill"
              role="progressbar"
              aria-label="Example 5px high"
              aria-valuenow="60"
              aria-valuemin="0"
              aria-valuemax="100"
              style="height: 5px; background-color: #eff2ff"
            >
              <div class="progress-bar rounded-pill" style="width: 60%"></div>
            </div>
            <span class="ms-4">4</span>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="text-center mt-4 mt-lg-0">
            <h1 class="fs-40 mb-2">4.28</h1>
            <ul
              class="ps-0 mb-3 list-unstyled d-flex gap-2 justify-content-center"
            >
              <li>
                <i class="ri-star-fill text-warning fs-30"></i>
              </li>
              <li>
                <i class="ri-star-fill text-warning fs-30"></i>
              </li>
              <li>
                <i class="ri-star-fill text-warning fs-30"></i>
              </li>
              <li>
                <i class="ri-star-fill text-warning fs-30"></i>
              </li>
              <li>
                <i class="ri-star-line text-light fs-30"></i>
              </li>
            </ul>
            <span class="ms-4">of 3250 Reviews</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Ratings",
});
</script>
